exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".divIcon {\n  cursor: pointer;\n  font-size: 15px;\n  color: #999; }\n\n.divIcon:hover {\n  color: #000; }\n\n.divMessage {\n  position: absolute;\n  font-size: 15px;\n  text-align: justify; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/adri9/Escritorio/admin-everpath/src/app/componentes/graficas/infoDash/infoDash.component.scss
// module id = ../../../../../src/app/componentes/graficas/infoDash/infoDash.component.scss
// module chunks = main